type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
};

const SupportModal = ({ isOpen, onClose, title }: Props) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-2 sm:p-4"
      onClick={onClose}>
      <div
        className="relative bg-white p-6 w-[420px] max-w-3xl max-h-[calc(100dvh-1rem)] sm:max-h-[90vh] rounded-3xl shadow-xl overflow-y-auto overscroll-y-none hide-scrollbar"
        onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className="absolute right-6 top-6 text-gray-500 hover:text-black ring-1 ring-gray-300 rounded-xl px-2.5 py-1">
          ✕
        </button>
        <div className="flex flex-col gap-4">
          <h2 className="text-2xl font-semibold">{title}</h2>
          <p className="text-gray-700 text-sm text-left">
            Please send us an email at{' '}
            <a
              href="mailto:support@whenwemeet.xyz"
              className="text-blue-600 hover:text-blue-800 hover:underline font-medium">
              support@whenwemeet.xyz
            </a>{' '}
            and we’ll get back to you as soon as possible.
          </p>
          <button
            onClick={onClose}
            className="mt-4 bg-gray-100 hover:bg-gray-200 text-gray-800 py-2 px-4 rounded-lg text-sm font-medium transition-colors">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupportModal;
